import type { FormSubmissionRequest, FormSubmissionResponse } from '@qdf/shared';
import { apiRequest } from './client.js';

export async function submitForm(
  data: FormSubmissionRequest,
): Promise<FormSubmissionResponse> {
  return apiRequest<FormSubmissionResponse>('/v1/form-submissions', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}
